import { useToast } from '@ordr-as/umami-react/toast';
import { useIntl } from 'react-intl';
import { usePrintReceiptForBookingUsingMessage } from '@ordr-as/ordr-service-types/epos';
import { useCallback, useMemo } from 'react';

const usePrintReceipt = (onSuccess: () => void = () => undefined) => {
  const { mutate: print, isPending } = usePrintReceiptForBookingUsingMessage();
  const intl = useIntl();
  const toasts = useToast();

  const printReceipt = useCallback(
    (reference: string, placementId: number) => {
      print(
        { orderReference: reference, data: { placementId } },
        {
          onError: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushError({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.error' })}</span>,
              });

              setTimeout(() => {
                toasts.remove(placementId.toString());
              }, 1000);
            }
          },
          onSuccess: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushSuccess({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.success' })}</span>,
              });
              onSuccess();
            }
          },
        }
      );
    },
    [intl, onSuccess, print, toasts]
  );

  return useMemo(
    () => ({
      isPending,
      printReceipt,
    }),
    [isPending, printReceipt]
  );
};

export default usePrintReceipt;
